import './register.scss';
import React from 'react';
import { Row, Col, Alert, Button, TabContent, TabPane } from 'reactstrap';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Translate } from 'react-jhipster';
import { login } from 'app/shared/util/utilities';
import { width } from '@fortawesome/free-solid-svg-icons/faSave';

export interface RegisterBottomProps extends StateProps {
  isInsurance: boolean;
}
export interface RegisterBottomSate {
  clickButton: boolean;
}

export class RegisterBottom extends React.Component<RegisterBottomProps, RegisterBottomSate> {
  state: RegisterBottomSate = {
    clickButton: false
  };

  invokeRegisterOther = () => {
    this.setState({
      clickButton: true
    });
  };

  invokeSignIn = () => {
    // login(this.props.config);
    window.location.href = this.props.config.urlRedirectDVC;
  };

  render() {
    if (this.state.clickButton) {
      return <Redirect push to="/register" />;
    }
    return (
      <div>
        {this.props.isInsurance ? null : (
          <div>
            <Row style={{ flex: 1, width: 'auto', margin: '0 auto' }}>
              <Col style={{ flex: 0.4 }}>
                <hr />
              </Col>
              <Col style={{ flex: 0.2, color: '#1E2F41' }}>Hoặc</Col>
              <Col style={{ flex: 0.4 }}>
                <hr />
              </Col>
            </Row>
            <Row style={{ flex: 1, width: 'auto', marginTop: '15px' }}>
              <Col style={{ display: 'flex', alignItems: 'center' }}>
                <Button className="btn-register-white" onClick={this.invokeRegisterOther} style={{ margin: '0 auto' }} block>
                  Chọn hình thức đăng ký khác
                </Button>
              </Col>
            </Row>
          </div>
        )}

        <Row style={{ flex: 1, marginTop: '80px' }}>
          <Col style={{ flex: 1, textAlign: 'center' }}>
            <label style={{ marginRight: '5px' }}>Đã có tài khoản? </label>
            <label style={{ color: '#4D9235' }} onClick={this.invokeSignIn}>
              Đăng nhập
            </label>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ applicationProfile }: IRootState) => ({
  config: applicationProfile.config
});

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(RegisterBottom);
